import { DisplayOrder, ShipmentWithOrderLines } from '@ravago/shared/page-data/models/elements';

import { OrderFilters } from '../../components/content/order-overview/models/order-filters';

export class OrderFilterUtils {
   static readonly onSearch = (query: string | undefined, orders: DisplayOrder[]): DisplayOrder[] => {
      let filteredOrders = [...orders];
      if (query) {
         const word = query.toLowerCase();
         filteredOrders = orders.filter(
            (item) =>
               item.product.description.toLowerCase().includes(word) ||
               item.orderNumber.toLowerCase().includes(word) ||
               item.customerProductReference?.toLowerCase().includes(word) ||
               item.customerOrderReference?.toLowerCase().includes(word) ||
               item.shipmentIds?.some((shipmentId) => String(shipmentId).toLowerCase().includes(word))
         );
      }

      return filteredOrders;
   };

   static readonly onFilter = (filters: OrderFilters, orders: DisplayOrder[]): DisplayOrder[] =>
      orders
         .filter((order) => OrderFilterUtils.onFilterCalloff(filters.callOff, order))
         .filter((order) => OrderFilterUtils.onFilterDeliveryDateFrom(filters.deliveryDateFrom, order))
         .filter((order) => OrderFilterUtils.onFilterDeliveryDateUntil(filters.deliveryDateTo, order))
         .filter((order) => OrderFilterUtils.onFilterDeliveryAddress(filters.deliveryAddressIds, order));

   static readonly onFilterCalloff = (isFiltered: boolean, order: DisplayOrder) => {
      if (isFiltered) {
         return order.isCallOff;
      }
      return true;
   };

   static readonly onFilterDeliveryDateFrom = (date: string, order: DisplayOrder) => {
      if (date !== '') {
         const fromDateSelected = new Date(date).getTime();

         const fromDateOrder = new Date(order.deliveryDate.from).getTime();

         return fromDateOrder >= fromDateSelected;
      }
      return true;
   };

   static readonly onFilterDeliveryDateUntil = (date: string, order: DisplayOrder) => {
      if (date !== '') {
         const untilDateSelected = new Date(date).getTime();

         const untilDateOrder = new Date(order.deliveryDate.until ?? order.deliveryDate.from).getTime();

         return untilDateOrder <= untilDateSelected;
      }
      return true;
   };

   static readonly onFilterDeliveryAddress = (deliveryAddressIds: number[], order: DisplayOrder) => {
      if (deliveryAddressIds.length === 0) return true;
      return order.deliveryTermAddress ? deliveryAddressIds.includes(order.deliveryTermAddress.id) : false;
   };

   static readonly onFilterShipmentOrders = (shipmentOrders: ShipmentWithOrderLines[], filters: OrderFilters): ShipmentWithOrderLines[] => {
      const filteredShipmentOrderLines: ShipmentWithOrderLines[] = [];

      for (let i = 0; i < shipmentOrders.length; i += 1) {
         const searchData = OrderFilterUtils.onSearch(filters.search, shipmentOrders[i].orderLines);
         const filteredData = OrderFilterUtils.onFilter(filters, searchData);

         if (filteredData.length > 0) {
            filteredShipmentOrderLines.push({
               shipmentId: shipmentOrders[i].shipmentId,
               orderLines: filteredData
            });
         }
      }

      return filteredShipmentOrderLines;
   };
}
